export { OntosStore, makeRelId } from "./store.js";
export type { TraverseOptions, ProposalRow } from "./store.js";
export { SCHEMA } from "./schema.js";
